const textColor = '#fff';
const inputWidth = 270;

export { inputWidth, textColor };
